
import React from 'react'
import { mdx } from '@mdx-js/react'

/* @jsxRuntime classic */
/* @jsx mdx */



const layoutProps = {
  
};
const MDXLayout = "wrapper"
export default function MDXContent({
  components,
  ...props
}) {
  return <MDXLayout {...layoutProps} {...props} components={components} mdxType="MDXLayout">
    <b>Aldo R., verstorben am 3.12.2020</b>
    <br />
    <br />
    <i>In der Todesanzeige von Aldo R. schreiben die Hinterbliebenen:</i>
    <br />
    <p>
  «Seine Lebensgeschichte war geprägt vom einfachen Leben, von der italienischen
  Resistenza; seiner Migration, seinen privaten Freuden und Schicksalsschlägen,
  seiner beruflichen Tätigkeit, seiner geliebten Gartenarbeit und seinem nie
  endenden politischen Interesse. Nun sagen wir für immer ciao...»
    </p>
    <p>
  Seine Tochter erzählt: «Am Samstag hiess es, dass alle Bewohner getestet
  werden. Am Montag, nach über 48 Stunden Wartezeit, kam das Testergebnis per
  Telefon: positiv. Man sagte uns dann sofort: ‹Es tut uns leid, ihr Vater wird
  daran sterben!› Bereits von der Krankheit schwer gezeichnet, besuchten wir ihn
  am Montag, eingehüllt in Schutzkleidern, im Altersheim und im Bewusstsein,
  dass wir ein letztes Mal Ciao sagen können. Danach war er nicht mehr
  ansprechbar und verstarb. Für uns ist die Situation immer noch surreal.»
    </p>
    </MDXLayout>;
}

;
MDXContent.isMDXComponent = true;